import request from '@/utils/request'

/**
 * 获取调剂入库列表
 * @param {*} data
 * @returns
 */
export const getTJRKList = (data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/tjrk/list`,
    data: data
})

/**
 * 获取调剂证列表
 * @param {*} data
 * @returns
 */
 export const getTJZList = (data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/tjrk/selectTjzList`,
    data: data
})
/**
 * 获取运输证列表
 * @param {*} id
 * @param {*} data
 * @returns
 */
 export const getYSZList = (id, data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/tjrk/selectYszList/${id}`,
    data: data
})

/**
 * 根据调剂证主键查询调剂证等信息
 * @param {*} id
 * @returns
 */
 export const getTJZ = (id) => request({
    method: 'get',
    url: `/yzdservice/enterprise/dwCk/tjrk/selectTjzxxById/${id}`
})
/**
 * 获取调剂入库详情
 * @param {*} id
 * @returns
 */
 export const getTJRK = (id) => request({
    method: 'get',
    url: `/yzdservice/enterprise/dwCk/tjrk/detail/${id}`
})


/**
 * 新增/编辑调剂入库
 * @param {*} data
 * @returns
 */
export const addOrUpdSaveTJRK = (data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/tjrk/addOrUpdSave`,
    data: data
})


/**
 * 删除调剂入库
 * @returns
 * @param id
 */
export const deleteTJRK = (id) => request({
    method: 'delete',
    url: `/yzdservice/enterprise/dwCk/tjrk/remove/${id}`
})

/**
 * （变更保存前）校验库存是否为负数
 * @param {*} data
 * @returns
 */
export const changePdkc = (data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/tjrk/changePdkcByTjrk`,
    data
})
/**
 * 变更调剂入库
 * @param {*} data
 * @returns
 */
export const saveChangeApply = (data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/tjrk/saveChangeApply`,
    data
})

/**
 * 导出
 * @param {*} data
 * @returns
 */
export const excelwriter = (data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/tjrk/excelwriter`,
    data,
    responseType: 'blob'
})

